import { ShipmentBatchEvent, ShipmentEvent } from '@/model';
import { buildShipmentEvent } from '@/util';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment/batch/event';

export class ShipmentBatchEventController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async createBatch(
    shipmentIds: Array<number>,
    event: ShipmentBatchEvent,
  ): Promise<ShipmentEvent[]> {
    const response = await this.http.put<ShipmentEvent[]>(
      `${shipmentIds}`,
      event,
    );
    return response.data.map(buildShipmentEvent);
  }
}
